import { useAuth } from "@/src/contexts/auth.context";
import { useTheme } from "@/src/styles/theme-provider";
import { LinearGradient } from "expo-linear-gradient";
import React from "react";
import { useTranslation } from "react-i18next";
import { formatUserName } from "@/src/utils/string.utils";
import { ImageBackground, Text, View } from "react-native";

type UserDashboardHeaderProps = Readonly<{
  subtitleKey?: string;
  bgImageName: keyof typeof images;
}>;

const images = {
  office: require("@/src/assets/images/office.jpeg"),
  rewardly: require("@/src/assets/images/rewardly.jpg"),
} as const;

const UserDashboardHeader = ({
  subtitleKey = "LABEL_UAM_DASHBOARD",
  bgImageName
}: UserDashboardHeaderProps) => {
  const { t } = useTranslation();
  const { themeVars } = useTheme();
  const { user } = useAuth();

  const displayName =
    (user && formatUserName(user.firstName, user.lastName)) ||
    t("LABEL_UNKNOWN_USER");

  const gradientColors = [
    `${themeVars["--color-chalk-default"]}FF`,
    `${themeVars["--color-chalk-default"]}00`,
  ] as [string, string];

  const bgSource =
    images[bgImageName as keyof typeof images] ?? images.office;

  return (
    <View className="flex-row flex-1 rounded-2xl justify-center items-center min-h-[96px] md:min-h-[130px] overflow-hidden">
      <ImageBackground
        className="flex-1 rounded-2xl overflow-hidden md:border md:border-ash-3"
        source={bgSource}
        style={{
          height: "100%",
          width: "100%",
          backgroundColor: "transparent",
        }}
        resizeMode="cover"
      >
        <LinearGradient
          className="flex-1 justify-center px-4"
          style={{ width: "100%", height: "100%" }}
          colors={gradientColors}
          start={{ x: 0, y: 0.5 }}
          end={{ x: 1, y: 0.5 }}
          locations={[0.3, 1]}
        >
          <Text
            className="text-xl md:text-3xl font-semibold text-onyx"
            numberOfLines={1}
          >
            {t("LABEL_WELCOME")}, {displayName}
          </Text>
          <Text className="text-slate text-xs md:text-sm">
            {t(subtitleKey)}
          </Text>
        </LinearGradient>
      </ImageBackground>
    </View>
  );
};

export default UserDashboardHeader;
